const PaymentCalculator = require('@/libraries/DigiTickets/Payment/PaymentCalculator');

/**
 * @typedef {object} ChangeAmounts
 * @property {number} amountDue
 * @property {number} amountTendered
 * @property {number} amountChange
 * @property {string} changePaymentMethodRef
 * @property {number} amountCashback
 * @property {number} amountGratuity
 * @property {number} remainingBalance
 */

/**
 * Standalone method to calculate the amount such as tendered, change, cashback, etc.
 * used in the change modal. So that we can easily test this in isolation.
 *
 * @param {Cart} cart
 * @param {Order} order
 * @param {CheckoutResult} checkoutResult
 *
 * @returns {ChangeAmounts}
 */
const calculateChangeAmounts = (cart, order, checkoutResult) => {
    // Use the cart total as the amount due instead of the order total.
    let amountDue = cart.getTotalDue();

    const newPayments = checkoutResult.newPayments;

    // Add up the tendered amount from all *new* payments as the amount tendered.
    let amountTendered = PaymentCalculator.getTotalTendered(newPayments);

    // Calculate the change (tendered - due).
    // For balance payments there may be a desire to pay less than the order total at this time,
    // in which case there can be change even if there is still an outstanding balance on the order.
    let amountChange = PaymentCalculator.getChangeDue(amountDue, amountTendered);

    // What kind of change is due? It could be cash or flexi voucher.
    // Note this will be populated even if the amountChange is 0.
    let changePaymentMethodRef = PaymentCalculator.getChangePaymentMethod(
        amountChange,
        newPayments
    );

    // Add up the cashback from all *new* payments.
    let amountCashback = PaymentCalculator.getTotalCashbackAmount(newPayments);

    // Add up the gratuity from all *new* payments.
    let amountGratuity = PaymentCalculator.getTotalGratuityAmount(newPayments);

    // Calculate the remaining order balance.
    // (Order total - sum of *all* payments).
    let remainingBalance = order.getRemainingBalance();

    return {
        amountDue,
        amountTendered,
        amountChange,
        changePaymentMethodRef,
        amountCashback,
        amountGratuity,
        remainingBalance,
    };
};

module.exports = {
    calculateChangeAmounts,
};
